export const makeLyricsCleanupJob = (result, song) => ({
  ...result,
  id: result.jobId,
  jobId: result.jobId,
  songId: result.songId || song.id,
  status: result.status || 'pending',
  currentStage: result.currentStage || 'cleaning_lyrics',
  progress: result.progress || 0,
  song: result.song || song,
  _creationTime: result._creationTime || Date.now(),
})

export const requestPracticeSong = async ({ song, ensureCleanup }) => {
  const result = await ensureCleanup(song.id)
  return result?.processing
    ? { ready: false, result, job: makeLyricsCleanupJob(result, song) }
    : { ready: true, song }
}

export const loadCompletedPracticeSong = async ({ jobStatus, deferredSong, getSong }) => {
  if (jobStatus?.status !== 'completed' || !deferredSong) return null
  const song = await getSong(deferredSong.songId)
  if (!song) throw new Error('Refreshed song was not found')
  return song
}

export const isLyricsCleanupJob = (job) => (
  job?.jobType === 'lyrics_cleanup' && Boolean(job?.jobId) && Boolean(job?.songId)
)

export const loadCompletedSubmittedSong = async ({ response, getSong }) => {
  if (response?.status !== 'completed' || !response?.songId) return null
  const song = await getSong(response.songId)
  if (!song) throw new Error('Completed song was not found')
  return song
}

export const shouldRefreshUrlPlaceholder = (song, jobStatus) => (
  song?.status === 'processing'
  && (song.youtubeUrl === jobStatus?.youtubeUrl || song.youtubeUrl === jobStatus?.url)
)
